/*
 * Pandectes' own cookie-consent widget (<pandectes-cmp>) sometimes never
 * removes itself from the page after a choice is made, even though the
 * consent cookie is written correctly and instantly. This never touches
 * consent itself - it only force-hides the widget's own DOM element once a
 * decision has actually been recorded, and gives Pandectes a grace period
 * to close itself normally first.
 */
(function () {
  function getStatus() {
    var m = document.cookie.match(/(?:^|; )_pandectes_gdpr=([^;]+)/);
    if (!m) return null;
    try {
      return JSON.parse(atob(decodeURIComponent(m[1]))).status;
    } catch (e) {
      return null;
    }
  }

  var decidedAt = null;
  var iv = setInterval(function () {
    var host = document.querySelector('pandectes-cmp');
    if (!host) {
      clearInterval(iv);
      return;
    }
    var status = getStatus();
    if (status !== 'allow' && status !== 'deny') return;
    if (decidedAt === null) decidedAt = Date.now();
    if (getComputedStyle(host).display === 'none') {
      clearInterval(iv);
      return;
    }
    if (Date.now() - decidedAt > 1500) {
      host.style.setProperty('display', 'none', 'important');
      clearInterval(iv);
    }
  }, 300);
})();

/*
 * Mobile only: show "Accepteren" above "Afwijzen" (desktop keeps Pandectes'
 * own order). The widget lives in a shadow root, so a normal stylesheet can't
 * reach it - inject one rule into the shadow root instead. Purely visual; it
 * does not touch consent.
 */
(function () {
  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    var host = document.querySelector('pandectes-cmp');
    var root = host && host.shadowRoot;
    if (root && !root.getElementById('gg-cmp-order')) {
      var st = document.createElement('style');
      st.id = 'gg-cmp-order';
      st.textContent = '@media (max-width: 639px) { .actions .group .allow { order: -1 !important; } }';
      root.appendChild(st);
    }
    if ((root && root.getElementById('gg-cmp-order')) || tries > 50) clearInterval(iv);
  }, 300);
})();
